import { render } from "./AppContent.vue?vue&type=template&id=4d58ef90"
import script from "./AppContent.vue?vue&type=script&lang=js"
export * from "./AppContent.vue?vue&type=script&lang=js"

import "./AppContent.vue?vue&type=style&index=0&id=4d58ef90&lang=css"
import "./AppContent.vue?vue&type=style&index=1&id=4d58ef90&lang=scss"
script.render = render

export default script